import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Crown, Sparkles, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useSubscription } from '@/context/SubscriptionContext';
import { useLanguage } from '@/context/LanguageContext';
import { useAuth } from '@/context/AuthContext';

export const VipUpgradeBanner = ({ onDismiss }) => {
  const navigate = useNavigate();
  const { subscriptionStatus } = useSubscription();
  const { isSpanish } = useLanguage();
  const { isAuthenticated, user } = useAuth();
  
  if (!isAuthenticated) return null;
  if (user?.is_admin) return null;
  if (!subscriptionStatus) return null;
  if (subscriptionStatus.status === 'active' || subscriptionStatus.status === 'trial' || subscriptionStatus.status === 'admin' || subscriptionStatus.is_gifted) {
    return null;
  }
  
  return (
    <div className="bg-gradient-to-r from-purple-600 to-indigo-500 text-white py-1 px-3 relative">
      <div className="container mx-auto flex items-center justify-center gap-2 text-xs">
        <Crown className="h-3 w-3 text-yellow-300" />
        <span className="font-medium">
          {isSpanish ? 'Sin anuncios con VIP' : 'Go Ad-Free with VIP'}
        </span>
        <Button
          size="sm"
          variant="secondary"
          className="bg-white text-purple-600 hover:bg-purple-50 h-5 px-2 text-[10px] font-medium"
          onClick={() => navigate(isAuthenticated ? '/account' : '/login')}
          data-testid="vip-upgrade-btn"
        >
          <Sparkles className="h-2.5 w-2.5 mr-0.5" />
          {isSpanish ? 'VIP' : 'VIP'}
        </Button>
        {onDismiss && (
          <button
            onClick={onDismiss}
            className="absolute right-2 top-1/2 -translate-y-1/2 p-0.5 hover:bg-white/10 rounded"
            aria-label="Dismiss"
          >
            <X className="h-3 w-3" />
          </button>
        )}
      </div>
    </div>
  );
};

export default VipUpgradeBanner;
